// Generated by CoffeeScript 1.12.7
(function() {
  module.exports = {
    None: 0,
    OpenTag: 1,
    InsideTag: 2,
    CloseTag: 3
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/xmlbuilder/lib/WriterState.js
// module id = KjrJ
// module chunks = 0